const PathConstants = {
  Home: "https://www.getclaimable.com/",
  Root: "/",

  // Account
  AccountOverview: "/account",
  Appeals: "/appeals",

  MyAppealsDetail: "/my-appeals/:appealId",
  MyAppealsInsurance: "/my-appeals/:appealId/insurance",
  MyAppealsInsurancePrimaryEnrollee:
    "/my-appeals/:appealId/insurance/primary-enrollee",
  MyAppealsInsuranceDenyingParty:
    "/my-appeals/:appealId/insurance/denying-party",
  MyAppealsPatientInfo: "/my-appeals/:appealId/patient-info",
  MyAppealsPatientInfoWhoIsAppealFor:
    "/my-appeals/:appealId/patient-info/who-is-appeal-for",
  MyAppealsDenialReason: "/my-appeals/:appealId/denial-reason",
  MyAppealsDenialReasonSubDenialReason:
    "/my-appeals/:appealId/denial-reason/sub-denial-reason",
  MyAppealsDenialReasonAlternativeCondition:
    "/my-appeals/:appealId/denial-reason/alternative-condition",
  MyAppealsDenialReasonBmiCriteriaFollowUp:
    "/my-appeals/:appealId/denial-reason/bmi-criteria-follow-up",
  MyAppealsDenialReasonOtherAppealSituations:
    "/my-appeals/:appealId/denial-reason/other-appeal-situations",

  // Report Appeal Result Flow
  ReportAppealResult: "/report-appeal-result/:appealId",
  AppealWon: "/appeal-won",
  ReviewAndShare: "/review-and-share",
  NoResultNotEnoughTime: "https://www.getclaimable.com/have-you-heard-back",
  NoResultShouldHaveHeardBack:
    "https://www.getclaimable.com/should-have-heard-back",
  DenialUpheld: "/denial-upheld",
  DenialUpheldClaimFile: "/denial-upheld-claim-file",
  AppealLost: "/appeal-lost",
  NotifyMe: "https://www.getclaimable.com/notify-me",

  // Eligibility Flow

  CoverageFundQualify: "/coverage-fund-qualify",
  CoverageFundEligibility: "/coverage-fund-eligibility",
  MedicationConditionEligibility: "/medication-condition-eligibility",
  DenialReasonEligibility: "/denial-reason-eligibility",
  SubDenialReasonEligibility: "/sub-denial-reason-eligibility",
  AlternativeConditionEligibility: "/alternative-condition-eligibility",
  BMICriteriaFollowUp: "/bmi-criteria-follow-up",
  WhoIsAppealFor: "/who-is-appeal-for",
  PatientInfo: "/patient-info",
  CoverageFundNotQualify: "/coverage-fund-not-qualify",
  NotifyMeDenial: "https://www.getclaimable.com/notify-me-denial",
  SucraidRedirect: "https://partners.getclaimable.com/sucraid",
  StrensiqRedirect: "https://partners.getclaimable.com/strensiq",

  // Setup Flow

  LetsGetStarted: "/lets-get-started",
  UploadInsuranceCard: "/your-insurance-card",
  UploadProcessing: "/processing-supporting-data",
  ConfirmInsuranceDetails: "/confirm-insurance-details",
  PrimaryEnrollee: "/primary-enrollee",
  DenyingPartyPage: "/denying-party",
  OtherAppealSituationsPage: "/other-appeal-situations",

  // Experience Flow

  AppealSurvey: "/appeal-survey",
  SurveyJs: "/appeal-survey-new",
  ExperienceOverview: "/your-experience",
  ExperienceSummary: "/nearly-complete",

  // Letter Creation Flow

  LetterBuildingInterstitial: "/getting-ready",
  AppealOverview: "/appeal-overview",
  PreviewComplete: "/ready-to-send",
  PreviewAndReviewAppealLetter: "/review-your-appeal-letter",
  UploadAdditionalDocuments: "/upload-additional-documents",
  PatientData: "/patient-data",
  AppealDepartment: "/appeal-department",
  EmployerAddress: "/employer-address",
  CcDestinations: "/cc-destinations",

  // Payment Flow

  PrePayment: "/pre-payment",
  ReadyToSubmit: "/ready-to-submit",
  ReviewAppeal: "/review-appeal",
  AppealSubmitting: "/appeal-submitting",
  PaymentComplete: "/purchase-complete",
  NotFound: "*",

  // Resume

  ResumeAppeal: "/resume-appeal/:appealId",

  UpdateAppealStatus: "/update-appeal-status/:encryptedToken",
};

export default PathConstants;
